export default __webpack_public_path__ + "navigation-overview-header-image-1200-b531d81659f5fb4569e855706d893680.png";